import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./registrationfrom.css";
// import FormInputs from "./FormInputs";
// import DropDown from "./Dropdown";
import FormInputs from '../../Components/Shared/FormInputs/FormInputs'
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import searchIcon from "../../Assets/Images/EployeeRegistration/search-icon.png";
import ToggleButton from "../../Components/Shared/ToggleButtons/ToggleButton";
import { fetchDeprtmentData } from "../../Redux/EmployeeRegistration/departmentSlice";
import { fetchGradeData } from "../../Redux/EmployeeRegistration/gradeSlice";
import EndPoints from "../../Api/Endpoints";

function JobDetails({ setJobDetails }) {
  const dispatch = useDispatch();
  const searchContainerRef = useRef(null);
  const searchDesignationRef = useRef(null);
  const { departmentdata } = useSelector((state) => state.department);
  const { gradedata } = useSelector((state) => state.grade);
  const [searchManagers, setSearchManagers] = useState("");
  const [filteredManagers, setFilteredManagers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [managerId, setManagerId] = useState("");
  const [searchDesignation, setSearchDesignation] = useState("");
  const [filteredDesignation, setFilteredDesignation] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    staff_number: "",
    hire_date: "",
    termination_date: "2050-01-01",
    department_id: null,
    grade_id: null,
    designation_id: 0,
    ofc_email_id: "",
    emp_type: "",
    status: "",
    aadhaar_no: "",
    pan_no: "",
    manager_emp_id: 0,
    app_user: 0,
    supervisor_flag: 0,
    faculty_flag: 0,
    comments_: "",
  });

  useEffect(() => {
    setJobDetails(values);
  }, [values, setJobDetails]);

  useEffect(() => {
    dispatch(fetchDeprtmentData());
    dispatch(fetchGradeData());
  }, [dispatch]);

  const onChange = (e) => {
    const { name, value } = e.target;

    setValues({ ...values, [name]: value });
    setJobDetails((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  // Manager Name
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchManagers(value);
    if (value.trim() === "") {
      setFilteredManagers([]);
      setSelectedItem(null);
      setManagerId("");
    }
  };

  const handleSearchClick = () => {
    if (searchManagers.trim() === "") {
      setFilteredManagers([]);
      return;
    }
    fetch(
      `${EndPoints.PRISM_GET_MANAGER_BY_SEARCH_KEY}?search_key=${encodeURIComponent(
        searchManagers
      )}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("other")}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      // .then((data) => {
      //   const filtered = data.filter((item) =>
      //     Object.values(item).some(
      //       (val) =>
      //         typeof val === "string" &&
      //         val.toLowerCase().includes(searchManagers.toLowerCase())
      //     )
      //   );
      //   setFilteredManagers(filtered);
      // })
      .then((data) => {
        const filtered = data.data.filter((item) =>  // ✅ data.data
          Object.values(item).some(
            (val) =>
              typeof val === "string" &&
              val.toLowerCase().includes(searchManagers.toLowerCase())
          )
        );
        setFilteredManagers(filtered);
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
      });
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);

    const managerName = item.manager_name
      ? `/ Report To ${item.manager_name}`
      : "";
    const middleName = item.emp_middle_name ? ` ${item.emp_middle_name}` : "";

    setSearchManagers(
      `${item.emp_last_name}, ${item.emp_first_name} ${middleName} / ${item.staff_number} ${managerName}`
    );

    setManagerId(item.staff_number);
    setFilteredManagers([]);

    // Update the values state
    setValues((prevValues) => ({
      ...prevValues,
      manager_emp_id: item.manager_emp_id,
    }));
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setFilteredManagers([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Designation
  const handleSearchChangeDesignation = (e) => {
    const value = e.target.value;
    setSearchDesignation(value);
    if (value.trim() === "") {
      setFilteredDesignation([]);
    }
  };

  const handleSearchDesignation = () => {
    if (searchDesignation.trim() === "") {
      setFilteredDesignation([]);
      return;
    }

    fetch(
      `${EndPoints.PRISM_GET_DESIGNATION_BY_SEARCH_KEY}?search_key=${encodeURIComponent(
        searchDesignation
      )}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("other")}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      // .then((data) => {
      //   const filtered = data.filter((item) =>
      //     Object.values(item).some(
      //       (val) =>
      //         typeof val === "string" &&
      //         val.toLowerCase().includes(searchDesignation.toLowerCase())
      //     )
      //   );
      //   setFilteredDesignation(filtered);
      // })
      .then((data) => {
        const filtered = data.data.filter((item) =>  // ✅ data.data
          Object.values(item).some(
            (val) =>
              typeof val === "string" &&
              val.toLowerCase().includes(searchDesignation.toLowerCase())
          )
        );
        setFilteredDesignation(filtered);
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
      });
  };

  const handleItemClickDesignation = (item) => {
    setSearchDesignation(`${item.designation_desc}`);
    setFilteredDesignation([]);

    // Update the values state
    setValues((prevValues) => ({
      ...prevValues,
      designation_id: item.designation_id,
    }));
  };

  const handleClickOutsideDesignation = (event) => {
    if (
      searchDesignationRef.current &&
      !searchDesignationRef.current.contains(event.target)
    ) {
      setFilteredDesignation([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDesignation);
    return () => {
      document.removeEventListener("click", handleClickOutsideDesignation);
    };
  }, []);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>Job Details</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <div className="grid-container">
            <div className="grid-item">
              <FormInputs
                label="Employee ID"
                type="text"
                name="staff_number"
                value={values.staff_number}
                onChange={onChange}
                maxLength={50}
                required
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Hire Date"
                type="date"
                name="hire_date"
                value={values.hire_date}
                onChange={onChange}
                required
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Term Date"
                type="text"
                name="termination_date"
                // value={values.termination_date}
                onChange={onChange}
                pattern="^[A-Za-z0-9]{3,16}"
                disabled
                bg="#d6d6d6"
              />
            </div>
            <div className="grid-item">
              {/* <div className="selecte-dropdown-items">
                <label>Department</label>
                <select
                  name="department_id"
                  value={values.department_id}
                  onChange={onChange}
                >
                  {departmentdata &&
                    departmentdata.map((dep) => (
                      <option key={dep.dept_id} value={dep.dept_id}>
                        {dep.dept_hod}
                      </option>
                    ))}
                </select>
              </div> */}
              <div className="selecte-dropdown-items">
                <DropDown
                  label="Department"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, department_id: selectedOption })
                  }
                  options={departmentdata.map((dept) => ({
                    label: dept.department_name,
                    id: dept.dept_id,
                  }))}
                  isRequired={true}
                />
              </div>
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                {/* <label>Grade</label>
                <select
                  name="grade_id"
                  value={values.grade_id}
                  onChange={onChange}
                >
                  {gradedata &&
                    gradedata.map((grade) => (
                      <option key={grade.grade_id} value={grade.grade_id}>
                        {grade.grade_name}
                      </option>
                    ))}
                </select> */}
                <DropDown
                  label="Grade"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, grade_id: selectedOption })
                  }
                  options={gradedata.map((grade) => ({
                    label: grade.grade_name,
                    id: grade.grade_id,
                  }))}
                  isRequired={true}
                />
              </div>
            </div>
            <div className="search-form" style={{ position: "relative" }}>
              <label>
                Designation<span className="city-required">*</span>
              </label>
              <div className="search-icon" ref={searchDesignationRef}>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchDesignation}
                  onChange={handleSearchChangeDesignation}
                />
                <span
                  className="search-button"
                  onClick={handleSearchDesignation}
                  style={{ marginTop: "8px" }}
                >
                  <img src={searchIcon} alt="search" />
                </span>
                {filteredDesignation.length > 0 && (
                  <div className="filter-search-designation">
                    {filteredDesignation.map((item, index) => (
                      <div
                        key={index}
                        className="designation-filter"
                        onClick={() => handleItemClickDesignation(item)}
                      >
                        <p>{`${item.designation_desc}`}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="grid-item">
              <FormInputs
                label="Official Email ID"
                type="email"
                name="ofc_email_id"
                value={values.ofc_email_id}
                onChange={onChange}
                maxLength={150}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
              />
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                {/* <label for="emptype">EmployeeType</label>
                <select
                  id="emptype"
                  name="emp_type"
                  required
                  value={values.emp_type}
                  onChange={onChange}
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="1">Employee</option>
                  <option value="0">Constructor</option>
                </select> */}
                <DropDown
                  label="Employee Type"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, emp_type: selectedOption })
                  }
                  options={[
                    { label: "Employee", id: "1" },
                    { label: "Contractor", id: "2" },
                  ]}
                  isRequired={true}
                />
              </div>
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                {/* <label for="Status">Status</label>
                <select
                  id="Status"
                  name="status"
                  required
                  value={values.status}
                  onChange={onChange}
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select> */}

                <DropDown
                  label="Status"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, status: selectedOption })
                  }
                  options={[
                    { label: "Active", id: 1 },
                    { label: "Inactive", id: 0 },
                  ]}
                  isRequired={true}
                />
              </div>
            </div>
            <div className="grid-item">
              <FormInputs
                label="Aadhaar Number"
                type="text"
                name="aadhaar_no"
                value={values.aadhaar_no}
                onChange={onChange}
                pattern="[0-9]{12}"
                maxLength={12}
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="PAN Number"
                type="text"
                name="pan_no"
                value={values.pan_no}
                onChange={onChange}
                pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                maxLength={10}
              />
            </div>
            <div className="check-box-items">
              <ToggleButton
                label="App User"
                setValues={(value) =>
                  onChange({ target: { name: "app_user", value } })
                }
              />
              <ToggleButton
                label="Supervisor"
                setValues={(value) =>
                  onChange({ target: { name: "supervisor_flag", value } })
                }
              />
              <ToggleButton
                label="Faculty"
                setValues={(value) =>
                  onChange({ target: { name: "faculty_flag", value } })
                }
              />
            </div>
            <div className="search-form">
              <label style={{color: "#6A6A6A", fontSize: "14px"}}>
                Manager Name<span className="city-required">*</span>
              </label>
              <div className="search-icon" ref={searchContainerRef}>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchManagers}
                  onChange={handleSearchChange}
                />
                <span
                  className="search-button"
                  onClick={handleSearchClick}
                  style={{ marginTop: "8px" }}
                >
                  <img src={searchIcon} alt="search" />
                </span>
                {filteredManagers.length > 0 && (
                  <div className="filter-search-items">
                    {filteredManagers.map((item, index) => (
                      <div
                        key={index}
                        className="filter-items"
                        onClick={() => handleItemClick(item)}
                      >
                        {/* <p>{`${item.emp_last_name}, ${item.emp_first_name} ${item.emp_middle_name} / ${item.staff_number} / Report To ${item.manager_name}`}</p> */}
                        <p>{`${item.emp_last_name}, ${item.emp_first_name}
                        ${item.emp_middle_name ? `${item.emp_middle_name}` : ""}
                        / ${item.staff_number}  
                        ${
                          item.manager_name
                            ? `/ Report To ${item.manager_name}`
                            : ""
                        }`}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="grid-item">
              <FormInputs
                label="Manager Id"
                type="text"
                value={managerId}
                disabled={selectedItem !== null}
              />
            </div>
            <div className="comments">
              <label>Comments</label>
              <textarea
                name="comments_"
                value={values.comments_}
                onChange={onChange}
                placeholder="Write your comment here..."
                maxLength={500}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default JobDetails;